import Model, { attr, belongsTo, type AsyncBelongsTo } from '@ember-data/model';
import { get } from '@ember/object';
import { service } from '@ember/service';
import type { Type } from '@warp-drive/core-types/symbols';
import type CurrentUserService from 'scaleflow/services/current-user';
import type IdeaModel from './idea';
import type InitiativeModel from './initiative';
import type LlModel from './ll';
import type PersonModel from './person';
import type QuestionModel from './question';
import type TeamModel from './team';
import type TfoModel from './tfo';
import type UncertaintyModel from './uncertainty';
import type WfaModel from './wfa';

export default class CommentModel extends Model {
  declare [Type]: 'comment';
  @service declare currentUser: CurrentUserService;

  commentables = [
    'question',
    'll',
    'tfo',
    'uncertainty',
    'wfa',
    'initiative',
    'idea',
  ] as const;

  @attr declare text: string;
  @attr declare text_delta: unknown;
  @attr declare updated_at: string;
  @attr declare mentions: unknown;
  @attr declare tags: unknown;
  @attr declare created_at: string;

  @belongsTo('question', { inverse: 'comments', async: true })
  declare question: AsyncBelongsTo<QuestionModel>;
  @belongsTo('ll', { inverse: 'comments', async: true })
  declare ll: AsyncBelongsTo<LlModel>;
  @belongsTo('tfo', { inverse: 'comments', async: true })
  declare tfo: AsyncBelongsTo<TfoModel>;
  @belongsTo('uncertainty', { inverse: 'comments', async: true })
  declare uncertainty: AsyncBelongsTo<UncertaintyModel>;
  @belongsTo('wfa', { inverse: 'comments', async: true })
  declare wfa: AsyncBelongsTo<WfaModel>;
  @belongsTo('person', { inverse: 'comments', async: true })
  declare author: AsyncBelongsTo<PersonModel>;
  @belongsTo('team', { inverse: null, async: true })
  declare team: AsyncBelongsTo<TeamModel>;
  @belongsTo('initiative', { inverse: null, async: true })
  declare initiative: AsyncBelongsTo<InitiativeModel>;
  @belongsTo('idea', { inverse: 'comments', async: true })
  declare idea: AsyncBelongsTo<IdeaModel>;

  get parentType() {
    let parentType: (typeof this.commentables)[number] | undefined = undefined;
    this.commentables.forEach((relationship) => {
      if (get(this, relationship).get('id') !== undefined) {
        parentType = relationship;
      }
    });

    return parentType;
  }

  get parentId() {
    let parentId: string | undefined = undefined;
    this.commentables.forEach((relationship) => {
      const id = get(this, relationship).get('id') as string | undefined;
      if (id) parentId = id;
    });

    return parentId;
  }

  get isMyComment() {
    return this.currentUser.id === this.author.content?.id;
  }
}
